import { render } from "./GivingTestsMini.vue?vue&type=template&id=f034cd84"
import script from "./GivingTestsMini.vue?vue&type=script&lang=js"
export * from "./GivingTestsMini.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__